import { render, staticRenderFns } from "./PatientProfileResume.vue?vue&type=template&id=2cfbd68e&scoped=true&"
import script from "./PatientProfileResume.vue?vue&type=script&lang=js&"
export * from "./PatientProfileResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfbd68e",
  null
  
)

export default component.exports